import React, { Component } from 'react';



//import './App.js';
//import { connect } from 'react-redux';
import Block from './Block/Block.js';
import Question from './Question/Question.js';
import ModalFinish from './ModalFinish/ModalFinish';

import AuthUserContext from './AuthUserContext';
import withAuthorization from './withAuthorization';
import firebase from 'firebase';
//import { auth } from '../firebase';

const pageStyle = {
  //backgroundImage: 'url(' + imgUrl + ')',
  padding: "60px",
  margin: "20px",
  textAlign: "justify",
  //WebkitTransition: 'all', // note the capital 'W' here
  //msTransition: 'all' // 'ms' is the only lowercase vendor prefix
};
const inlineHeader={//padding: "60px",
margin: "20px",
display: "inline",
fontSize: "1.5em",
marginTop: "0.83em",
marginBottom: "0.83em",
marginLeft: "0",
marginRight: "0",
fontWeight: "bold"
}

const answerText={textAlign: "justify"}

class HomePage extends Component {

//lsh=null;

// start and end are not used. Only for clarity. It is the array order that is used
dbBlocks= [
  {start: '1', end: '7',  blockHeader: 'Maintain Data Governance',
  blockBody: 'When processing personal data, Data protection and privacy (DPP) practitioners and enterprises must provide comprehensive governance to ensure conformance with GDPR requirements in a positive sense. The governing processes should enable all associates and other internal and external stakeholders to rely on a defined set of principles, policies and procedures that clearly define and explain how personal data may be processed and how senior management and other leadership functions support related activities.'},

  {start: '8', end: '13', blockHeader: 'Acquire, Identify and Classify Personal Data',
  blockBody: 'The acquisition of new personal data, identification of existing personal data and classification of information assets form the basis for managing and controlling such data in accordance with GDPR. DPP practitioners and enterprises must therefore provide a robust process that ensures GDPR-conformant processing as well as efficient data management. This process should also establish a defined and measurable life cycle for personal data, taking into account the principle of data minimization.'},

  {start: '14', end: '17', blockHeader: 'Manage Personal Data Risk',
  blockBody: 'Personal data processing is subject to a number of predefined risks that must be identified, evaluated and treated in an adequate and appropriate manner. The potential impact of these risks must be assessed and analyzed in view of existing risk mitigation measures. The risk management process must further manage residual risk, using recognized tools and standards.'},

{start: '18', end: '23', blockHeader: 'Manage Personal Data Security',
blockBody: 'Personal data processing requires adequate and comprehensive security around the information assets in scope. As personal data—and PII in the wider sense—represent a significant business and financial value, they should be treated accordingly and assigned an adequate level of protection in terms of confidentiality, integrity and availability. The security process for personal data should ensure a reasonable level of protection in view of the corresponding risks and impacts, making use of existing risk evaluations and impact analyses. It should further leverage existing information security processes to strengthen the protection of personal data.'},

{start: '24', end: '28', blockHeader: 'Manage the Personal Data Supply Chain',
blockBody: 'Where personal data is processed by more than one organization, the supply chain across all controllers and processors must be managed and controlled in accordance with GDPR. The management process therefore includes all controllers (jointly or separately) as well as any subprocessors handling personal data. The supply chain process is supported by processing agreements and supply chain controls, based on the risks and potential impacts along the chain. It further replicates the governance framework and its constituent parts from the primary level of controller(s) to any other actors in the supply chain.'},

{start: '29', end: '32',blockHeader: 'Manage Incidents and Breaches',
blockBody: 'DPP-related incidents and breaches must be reported in line with GDPR. This includes notification of supervisory authorities as well as communications with data subjects actually or potentially affected by the breach. From an organizational perspective, the incident (or eventual crisis) must be managed in terms of GDPR conformance as well as business continuity and recovery of services and information. This requires a robust incident and breach management process.'},

{start: '33', end: '35', blockHeader: 'Create and Maintain Awareness',
blockBody: 'Data protection and privacy (DPP) as fundamental values within an enterprise require awareness and ongoing information and education about DPP. The awareness process supports all other processes by explaining, communicating and reinforcing both GDPR requirements and good practice. The awareness process further includes education,training and qualification elements to ensure that enterprises have the requisite skill sets and develop their expertise in line with legislative and regulatory developments.'},

{start: '36', end: '40', blockHeader: 'Organize DPO Function',
blockBody: 'The GDPR mandates a data protection officer (DPO) as an individual or as a function. A process is needed to ensure that once established, the DPO performs regular tasks and interacts with other parts of the enterprise. In doing so, the DPO must further ensure conformance with laws and regulations, and specifically with GDPR. This entails the involvement of the DPO in any matters that might be related to personal data processing, effectively creating a broad function that should be structured and well organized.'},

{start: '41', end: '46', blockHeader: 'Maintain Internal Controls',
blockBody: 'Personal data processing in accordance with GDPR requires a comprehensive set of internal controls that ensure compliance and provide reasonable assurance. The process of maintaining internal controls over personal data processing should be fully aligned with the general system of internal controls operated by the enterprise. As a subset of controls, the PD processing controls should be supported by, and integrated with, enterprise-level and general controls to avoid duplication or ambiguity. The process of maintaining internal controls should further follow the personal data life cycle, as indicated below.'}


]

dbFA=require('./fa.js');
dbLA=require('./la.js');
dbPA=require('./pa.js');
dbNA=require('./na.js');

dbHeader=['Establish Data Protection and Privacy (DPP) Governance Framework',
'Maintain Processing Register',
 'Maintain Binding Corporate Rules (BCRs)',
 'Maintain Rules for Consent',
 'Maintain Rules for Data Subject Requests',
'Maintain Rules for Managing Complaints',
'Ensure Impartial Oversight',
'Manage Data Life Cycle',
'Conduct Personal Data Identification',
'Maintain Data Classification',
'Maintain Personal Data Register',
'Manage Special Categories Data',
'Manage Erasure (Right to be Forgotten)',
'Conduct Risk Evaluation',
'Conduct Data Protection Impact Assessment (DPIA)',
'Manage Risk Treatment',
'Conduct Risk Validation',
'Manage Anonymization and Pseudonymization',
'Manage Encryption',
'Manage Protection Levels',
'Manage Resilience',
'Manage Access',
'Manage Testing and Assessment',
'Manage Controllers and Processors',
'Manage Subprocessing',
'Maintain Processing Agreements',
'Manage Supply Chain Impact',
'Maintain Supply Chain Controls',
'Manage Notification',
'Manage Data Subject Communications',
'Perform Incident and Crisis Management',
'Manage Evidence and Claims',
'Maintain Enterprisewide Awareness',
'Manage Skills and Education',
'Manage Training',
'Maintain Data Protection Officer (DPO) Function',
'Manage Budget and Resources',
'Manage Organizational Interfaces',
'Manage Reporting',
'Manage External Services',
'Maintain Data Acquisition Controls',
'Maintain Processing Controls',
'Maintain Storage Controls',
'Maintain Deletion Controls',
'Maintain Monitoring Controls',
'Conduct Independent Review'

]



/* https://github.com/kolodny/immutability-helper */
 /*setState() also accepts a function. The function accepts the previous state and current props of the component
    which it uses to calculate and return the next state. */



toggleModalSave = () => {
  this.setState({
    isOpenSave: !this.state.isOpenSave
  });
}
toggleModalSubmit = () => {
  this.setState({
    isOpenSubmit: !this.state.isOpenSubmit
  });
}
 setBlockToCorrespondToQuestion= (cqn) =>{
   cqn=cqn+1;
  if(cqn >=1 && cqn <=7  ){this.setState( {currentBlock: 0 } );return;}
  if(cqn >=8 && cqn<=13  ) {this.setState( {currentBlock: 1 } );return;}
  if(cqn >=14 && cqn<=17  ){this.setState( {currentBlock: 2} );return;}
  if(cqn >=18 && cqn<=23  ){this.setState( {currentBlock: 3 } );return;}
  if(cqn >=24 && cqn<=28  ){this.setState( {currentBlock: 4 } );return;}
  if(cqn >=29 && cqn<=32 ){this.setState( {currentBlock: 5 } );return;}
  if(cqn >=33 && cqn<=35 ){this.setState( {currentBlock: 6 } );return;}
  if(cqn >=36 && cqn<=40 ){this.setState( {currentBlock: 7 } );return;}
  if(cqn >=41 && cqn<=46 ){this.setState( {currentBlock: 8 } );return;}

}
  nextQuestionHandler= () => {//cqn is the array index NOT the number

    console.log('Next was clicked ...previous question index' + this.state.currentQuestion)
    let cqn=this.state.currentQuestion +1;
    this.setBlockToCorrespondToQuestion(cqn);
      console.log('Next was clicked ...current question number' + cqn)
    if (cqn>45) {cqn=45;} else this.setState( {currentQuestion: cqn });
  }

  previousQuestionHandler= () => {
    //console.log('Next was clicked ...original question number' + this.state.currentQuestion)
    let cqn=this.state.currentQuestion -1;
    this.setBlockToCorrespondToQuestion(cqn);//if (choice ==0) style.backgroundColor='yellow';lockToCorrespondToQuestion(cqn);
    if (cqn<0) {cqn=0;} else this.setState( {currentQuestion: cqn });
  }

  historyHandler= (choice) => {
  let  h= [...this.state.history];
  const q=this.state.currentQuestion;
  h[q]=choice;
  console.log('new history ' + h[0] +' ' +h[1]+' ' +h[2] +' ' +h[3]  +' ' +h[4]   );
  this.setState( {history: h})
  //console.log("Home authUser"+ authUser);
  localStorage.setItem("questionnaire", JSON.stringify(h));
  }

  anyNotAnswered= (h) =>{   //change to 46!!!!!!!
    let notAnswered=true;
    let i;
    for (i = 0; i < 46; i++) { //46
            if (h[i]===0)  { alert("You have not answered question " +(i+1)); return notAnswered;}
                }
              return false;}





questionBodyFn=()=>{
  if(this.state.history[this.state.currentQuestion]===0 ) {return ' ';}
  else if(this.state.history[this.state.currentQuestion]===4 ) {return <span style={answerText}> {this.dbNA[this.state.currentQuestion]}</span>;}
  else
    if(this.state.history[this.state.currentQuestion]===3 ) {return <span style={answerText}> {this.dbPA[this.state.currentQuestion]}</span>;}
    else
      if(this.state.history[this.state.currentQuestion]===2 ) {return <span style={answerText}> {this.dbLA[this.state.currentQuestion]}</span>;}
      else
      if(this.state.history[this.state.currentQuestion]===1) {return <span style={answerText}> {this.dbFA[this.state.currentQuestion]}</span>;}
    }
// var element = document.getElementById('myElement'); // grab a reference to your element
// element.addEventListener('click', clickHandler);



/* 0 means no answer to question, 1 FA, 2 LA, 3 PA, 4 NA     pretending there are just 3 questions*/


constructor(props){
super(props);
const lsh=localStorage.getItem("questionnaire");
console.log("value of questionnaire Home  " + lsh);
console.log("value of history  Home  " + JSON.parse(lsh));

if (lsh === 'undefined'|| lsh === null)
{

  this.state = { history: [0,0,0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0,0,0,
  0,0,0,0,0,0,0,0,0,0,  0,0,0,0,0,0,0,0,0,0,   0,0,0,0,0,0],
  currentQuestion: 0,
  currentBlock:0,
  isOpenSave: false,
  isOpenSubmit:false
}
}
else{ this.state ={ history: JSON.parse(lsh),
  currentQuestion: 0,
  currentBlock:0,
  isOpenSave: false,
  isOpenSubmit:false,
  refresh:0
  }
  }
/*this.state ={ history: JSON.parse(lsh),
  currentQuestion: 0,
  currentBlock:0,
  isOpen: false,
  refresh:0
}*/
 //https://firebase.google.com/docs/auth/web/manage-users
 //const user = firebase.auth().currentUser;
 /*if (user) {
   console.log('value of user is  co'+ user.email);
 } else {
     console.log('No user ! saveHandler' + user.email);
 }
*/
/* 
const userId = firebase.auth().currentUser.uid; //This is the firebase unique user ID
console.log('User  uid !  (constructor) ' + userId);


const usersRef = firebase.database().ref('users/' + userId );
usersRef.on("value", function(snapshot) {

        var childData = snapshot.val();
          //var company=childData.company;
          //var username=childData.username;
          //var eligible=childData.eligible;
          //var telephoneNumber=childData.telephoneNumber;
          //var signupdate=childData.signupdate;
          var questionnaire=childData.questionnaire;  
          //var shouldemail=childData.shouldemail;

          this.state ={ history: JSON.parse(questionnaire),
            currentQuestion: 0,
            currentBlock:0,
            isOpen: false,
            refresh:0
          }

    } //end of snapshot functio
    ) // end of on
 */
/*
this.state ={ history: [0,0,0,0,0,0,0,0,0,0,   0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0,0,0,  0,0,0,0,0,0,0,0,0,0, 0,0,0,0,0,0,0,0],
  currentQuestion: 0,
  currentBlock:0,
  isOpen: false,
  refresh:0
  }
*/
this.finishedHandler = this.finishedHandler.bind(this);
this.historyHandler=this.historyHandler.bind(this);
this.questionBodyFn=this.questionBodyFn.bind(this);
this.anyNotAnswered=this.anyNotAnswered.bind(this);
this.previousQuestionHandler=this.previousQuestionHandler.bind(this);
this.nextQuestionHandler=this.nextQuestionHandler.bind(this);
this.retrieveHandler=this.retrieveHandler.bind(this);
this.saveHandler=this.saveHandler.bind(this);
this.findCurrentQuestion=this.findCurrentQuestion.bind(this);
//this.simulateClick=this.simulateClick.bind(this);
}
/*
componentDidUpdate(){
 this.setState(this.state);
   console.log("In componentDidUpdate"+this.state.history);
} */


/* static getDerivedStateFromProps(props, state) {
  if (props.selected !== state.selected) {
    return {
      selected: props.selected,
    };
  }
}
*/
saveHandler=(e)=>{
  e.preventDefault();
  const h=this.state.history;


  //https://firebase.google.com/docs/auth/web/manage-users
  const user = firebase.auth().currentUser;
    if (user) {
      console.log('value of user is  saveHandler'+ user.email);
    } else {
        console.log('No user ! saveHandler' + user.email);
    }


  var userId = firebase.auth().currentUser.uid; //This is the firebase unique user ID
  console.log('User  uid !  (saveHandler) ' + userId);

  ////const username = localStorage.getItem("username");
  //const company = localStorage.getItem("company");
  //const eligible = localStorage.getItem("eligible");
  //const telephoneNumber=localStorage.getItem("telephoneNumber");


//SEE https://stackoverflow.com/questions/40589397/firebase-db-how-to-update-particular-value-of-child-in-firebase-database
    const usersRef = firebase.database().ref('users/' + userId );
    usersRef.update({questionnaire: JSON.stringify(h), date: new Date().toJSON(),
      shouldemail: "no"});
    this.toggleModalSave(); //want to display finishing modal
    //set({questionnaire: JSON.stringify(h)});

    // Should now make eligible !== "true" in case someone else uses the browser?

  }





finishedHandler= (e) => {
e.preventDefault();
const h=this.state.history;

if (this.anyNotAnswered(h) ===false) { // only post if complete
console.log('finished ' + h[0] +h[1] +h[2]+ h[3] +h[4]+h[5]+ h[6] +h[7]+h[8]+ h[9]  +h[10]+h[11]+ h[12] +h[13] +h[14]+ h[15]  );

this.toggleModalSubmit(); //want to display finishing modal

//https://firebase.google.com/docs/auth/web/manage-users
const user = firebase.auth().currentUser;
  if (user) {
    console.log('value of user is  '+ user.email);
  } else {
      console.log('No user ! ' + user.email);
  }


  var userId = firebase.auth().currentUser.uid; //This is the firebase unique user ID
  console.log('User  uid !  (Home) ' + userId);

 
  const usersRef = firebase.database().ref('users/' + userId);
  //usersRef.update(cust);

  usersRef.update({questionnaire: JSON.stringify(h), date: new Date().toJSON(),
    shouldemail: "yes",
    currentQuestion:this.state.currentQuestion.toString(),
    currentBlock:this.state.currentBlock.toString(),
    uid:userId
  
  });


  // Should now make eligible !== "true" in case someone else uses the browser?

}
}

//simulateClick=(e)=> {
//    if (e!=null) e.click();
//  }

retrieveHandler=(e)=>{
  e.preventDefault();

  var userId = firebase.auth().currentUser.uid; //This is the firebase unique user ID
  console.log('User  uid !  (retrieveHandler) ' + userId);

var ref = firebase.database().ref('/users/' + userId);

  ref.once("value").then( function(snapshot) {
      console.log("Company  "+ snapshot.val().company)


          //     snapshot.forEach(function(child) {

  //console.log("key "+ child.key +": username in DB : "+ child.val().username + " id in DB : " + child.val().id + "Firebase ID of current user : " + user.uid);

                      var childData = snapshot.val();
                      var c=childData.company;
                      console.log("Company  retrieveHandler "+ c);
                      var n=childData.username;
                      console.log("username  retrieveHandler "+ n);
                      var eligible=childData.eligible;
                      console.log("eligible  retrieveHandler " + eligible);
                      var e =childData.id;
                      console.log("email stored retrieveHandler  "+ e);
                      var hist =JSON.parse(childData.questionnaire);
                      var histString=childData.questionnaire;
                      console.log("questionnaire in retrieveHandler  "+ hist);
                      //localStorage.setItem("questionnaire",childData.questionnaire);
                      //var hist2=hist.slice(0);
return histString;})
.then( function(histString) {console.log("history" +histString);
                        //this.updateHistory(hist);
localStorage.setItem("questionnaire",histString);
console.log("history and question no ");
                       //,() =>  this.forceUpdate()


                   })
}

updateHistory=(hist)=>{
  this.setState (
    (state) => {
        // Important: read `state` instead of `this.state` when updating.
        return { history: hist } //, currentQuestion:this.findCurrentQuestion(hist)
      })
}
//this.setState(this.state);



/*
You can execute a function after setState is finishing using the second param callback like:

this.setState({
    someState: obj
}, () => {
    this.afterSetStateFinished();
});
*/
findCurrentQuestion=(h )=>{
  console.log("inside findCurrentQuestion")
  let cq=-1;
  for (let i=0;i<46;i++){
    if (h[i]>0){cq=i;} }
  if (cq===-1) cq=0;
  console.log("current question number " + cq)
  return cq;
}

refreshQuestions = () =>
  this.setState({refresh: !this.state.refresh});

  render() {

    <AuthUserContext.Consumer>
     {/* {authUser => console.log("Home inside  render")}  */}
    </AuthUserContext.Consumer>
//let currentQN=this.findCurrentQuestion(this.state.history); //this.state.currentQuestion;
//console.log("this.findCurrentQuestion() " + this.findCurrentQuestion(this.state.history))
    let question=(<Question questionNumber={this.state.currentQuestion}
    //questionHeader = {this.dbQuestions[this.state.currentQuestion].questionHeader}
        questionHeader = {this.dbHeader[this.state.currentQuestion]}
        clickHistory={this.historyHandler}
        clickNext={this.nextQuestionHandler}
        clickBack={this.previousQuestionHandler}
        historyValue={this.state.history[this.state.currentQuestion]}
        questionBody= {this.questionBodyFn()}
        render={this.state.refresh}
        >
        </Question>)


    let block=(       <Block blockHeader = {this.dbBlocks[this.state.currentBlock].blockHeader}
    blockBody={this.dbBlocks[this.state.currentBlock].blockBody} > </Block>  )

    return (



    <div style= {pageStyle} >
        <h2 style={inlineHeader}>GDPR Assessment</h2>
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
        {this.state.currentQuestion===0?"":<button onClick={this.previousQuestionHandler}> Previous Question </button>}
        &nbsp;&nbsp;&nbsp;&nbsp;
        {this.state.currentQuestion===45?"":<button onClick={this.nextQuestionHandler}> Next question </button>}
        &nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;
        {this.state.currentQuestion===0?"":<button onClick={this.saveHandler}> Save Your Answers </button>}
        <ModalFinish show={this.state.isOpenSave}
                  onClose={this.toggleModalSave}>
                    Your answers have been saved to the server.
                          </ModalFinish>
        {/* &nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button onClick={this.retrieveHandler}> Retrieve Previously Saved Answers </button>
        */}
        &nbsp;&nbsp;&nbsp;&nbsp;
        &nbsp;&nbsp;&nbsp;&nbsp;
        {this.state.currentQuestion!==45?"":<button onClick={this.finishedHandler}> Submit Your Answers </button>}
        <ModalFinish show={this.state.isOpenSubmit}
                  onClose={this.toggleModalSubmit}>
                    Your answers have been submitted to the server. Your risk assessment will be emailed to you soon. Don't forget to sign out.
                          </ModalFinish>

 
        {block}
        {question}
      </div>


    );
  }

}

const authCondition = (authUser) => !!authUser;

export default withAuthorization(authCondition)(HomePage);



// WEBPACK FOOTER //
// ./src/components/Home.js